import React from 'react'

const Manual_reportes_info_lealtad = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold text-4xl text-[#002D33] mb-5">
          Reportes de información de lealtad
        </h2>
        <iframe
          src="https://scribehow.com/embed/Reportes_de_informacion_de_lealtad__5P-R7SlpTlC03Kw_rSRKLQ?as=scrollable"
          className="scribe-iframe-general-153"
          width="100%"
          height="4600"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_reportes_info_lealtad
